// Wedding data — single source of truth (edit aquí)
export const wedding = {
  bride: "Dulce Viridiana",
  brideFull: "Dulce Viridiana López Jiménez",
  groom: "José Manuel",
  groomFull: "José Manuel Porras Núñez",
  // Local time: October 24, 2026, 1:00 PM (Querétaro, Mexico — UTC-6)
  date: new Date("2026-10-24T13:00:00-06:00"),
  dateLabel: {
    day: "24",
    month: "Octubre",
    year: "2026",
    weekday: "Sábado",
    timeShort: "1:00 PM",
  },
  ceremony: {
    title: "Ceremonia",
    venue: "Templo de Rectoría San Pedro y San Pablo",
    address: "Querétaro, Querétaro",
    time: "1:00 PM",
    mapUrl: "https://maps.app.goo.gl/YNiCHNNu8KkMJC8u7",
  },
  reception: {
    title: "Recepción",
    venue: "Salón Quintas El Rey",
    address: "Buenavista, Querétaro, Querétaro",
    time: "3:00 PM",
    mapUrl: "https://maps.app.goo.gl/fe8TWFhVJKw2cQXg7",
  },
  dressCode: {
    code: "Formal / Etiqueta",
    note: "Reservamos el color blanco para la novia. Evitar los tonos rojo y blanco.",
  },
  whatsappPhone: "5214421234567", // edita con tu número real (formato internacional sin +)
  // Música de fondo: pega solo el ID del video de YouTube (11 caracteres). Vacío = sin música.
  musicVideoId: "woqxAEPzONs",
  musicUrl: "",
  family: {
    bridesParents: { label: "Padres de la Novia", names: ["Juan Manuel", "Francisca"] },
    groomsParents: { label: "Padres del Novio", names: ["Esteban", "Cruz"] },
    godparents: { label: "Padrinos de Velación", names: ["Miguel", "Olga"] },
  },
  story: [
    {
      year: "2018",
      title: "Cuando te conocí",
      text: "Una mirada inesperada, una conversación que no quería terminar. Sin saberlo, esa noche cambió todo.",
    },
    {
      year: "2021",
      title: "Crecimos juntos",
      text: "Aprendimos a caminar al mismo ritmo, a celebrar las pequeñas cosas y a sostenernos en las difíciles.",
    },
    {
      year: "2025",
      title: "Nuestro para siempre",
      text: "Con el corazón lleno y la certeza de que eras tú, decidimos escribir juntos el resto de la historia.",
    },
    {
      year: "2026",
      title: "Para siempre",
      text: "Hoy queremos celebrar contigo el inicio de nuestro nuevo capítulo.",
    },
  ],
  program: [
    { time: "1:00 PM", title: "Celebración Eucarística", icon: "rings" },
    { time: "2:30 PM", title: "Recepción en Salón Quintas El Rey", icon: "glass" },
    { time: "3:00 PM", title: "Comida", icon: "plate" },
    { time: "6:00 PM", title: "Partida de Pastel", icon: "cake" },
    { time: "7:00 PM", title: "Inicio Vals Familiar", icon: "music" },
    { time: "8:00 PM", title: "Fiesta", icon: "sparkle" },
  ],
  gallery: [
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_matrimonio-digital/artifacts/mt1ciyox_imagen.png",
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_matrimonio-digital/artifacts/2o3jk2e7_WhatsApp%20Image%202026-08-03%20at%2010.46.21%20PM.jpeg",
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_matrimonio-digital/artifacts/jjbhzs2f_imagen.png",
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_matrimonio-digital/artifacts/hj0ysgho_IMG-20260803-WA0038.jpg",
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_matrimonio-digital/artifacts/wa1ij0h1_imagen.png",
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_matrimonio-digital/artifacts/5i39d72e_IMG_20260827_164330.jpg",
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_matrimonio-digital/artifacts/5qu3g9ti_WhatsApp%20Image%202026-08-03%20at%2010.44.22%20PM.jpeg",
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_matrimonio-digital/artifacts/m4eye106_imagen.png",
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_matrimonio-digital/artifacts/wn6gojap_imagen.png",
  ],
  hero: "https://customer-assets-lxgj4vgw.emergentagent.net/job_matrimonio-digital/artifacts/jjbhzs2f_imagen.png",
};

export const fmtCountdown = (target) => {
  const now = new Date();
  const diff = Math.max(0, target.getTime() - now.getTime());
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((diff / (1000 * 60)) % 60);
  const seconds = Math.floor((diff / 1000) % 60);
  return { days, hours, minutes, seconds };
};
